/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, createRef, useRef, useEffect, memo } from "react";
import DataTable from "../../components/dataTable";
import { GridColumn as Column, getSelectedState } from "@progress/kendo-react-grid";
import { DialogComponent } from "../../components/dialog";
import { getUserCredential, getTenantCookieData } from "../../lib/cookies";
import { columnMenuProps } from "../../components/customColumnMenu";
import { Switch } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import CustomDropdown from "../../components/customDropdown";
import MultiSelectDropdown from "../../components/multiSelect";
import {
  getfilterDataString,
  GridColumnDataMapper,
  applyFormat,
  executeGetColumnOrderInfo,
  replaceEncKey,
} from "../../utils/utils";
import { GetPeriodsDataList, updateColumnReorderAsync } from "../../lib/common-service";
import { HeaderPage } from "../base/headerPage";
import { DEFAULT_SORT } from "../../constants/grid";
import { DELETE_BTN_ACTIONS, RESULT_TYPES } from "../../constants/constants";
import { CellRender, RowRender } from "../../components/renderers";
import { getter } from "@progress/kendo-react-common";
import { Window } from "@progress/kendo-react-dialogs";
import MessageSchema from "src/utils/messageSchema";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import userResultsFilterApi from "./result-filter-service";
import {
  GET_RESULT_CREDITS,
  GET_RESULT_INCENTIVES,
  GET_RESULT_MEASUREMENTS,
  GET_RESULT_PAYMENTS,
  GET_SELECT_GRID_COLUMN_XML,
} from "src/api-setup/api-endpoints";
import { errStatusHandler, POSTAPI } from "src/api-setup/api-helper";
import { setNewMessage } from "src/redux/actions/setting-actions";
import {
  extractIds,
  fetchExportProcName,
  fetchRuleResultValue,
  fetchScreenName,
  getModule,
  getResultType,
  getRuleResultMasterKeyByPathname,
  MULTI_SELECT_ALL_ID,
  PERIODSTYPE,
  SELECT_ALL,
} from "./resultUtils";
import { LoadingPanel } from "src/components/loadingPanel";
import { transformDateTime, convertTimeZone } from "src/lib/date-time.util";

const SELECTED_FIELD = "selected";

const initialSort = [
  {
    field: "a$position_name",
    dir: "asc",
  },
];

const ModalTitle = () => {
  return <span>Delete Result filter</span>;
};

const getPeriodKeys = (periodValue) => {
  if (periodValue === null || periodValue === undefined || periodValue === false) {
    return [];
  }

  if (Array.isArray(periodValue)) {
    return periodValue
      .map((item) => (item && typeof item === "object" ? item.id : item))
      .filter((item) => item !== null && item !== undefined && item !== "")
      .map((item) => item.toString());
  }

  if (typeof periodValue === "string") {
    return periodValue
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (typeof periodValue === "number") {
    return [periodValue.toString()];
  }

  if (typeof periodValue === "object") {
    if (periodValue.id !== null && periodValue.id !== undefined) {
      return [periodValue.id.toString()];
    }

    if (periodValue.in_period_mstr_key !== null && periodValue.in_period_mstr_key !== undefined) {
      return getPeriodKeys(periodValue.in_period_mstr_key);
    }
  }

  return [];
};

const DeleteResultFilter = (restProps) => {
  const { isResultDataLoad, resultAPICallData } = restProps;
  const cookiesData = getUserCredential();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };
  const history = useHistory();
  const dispatch = useDispatch();

  const divRef = createRef();
  const divRefForMultiSelectPeriod = useRef(null);
  const [sort, setSort] = useState(initialSort);

  const [stageChange, setStateChange] = useState("DEFAULT");
  const [modal, setModal] = useState(true);
  const [resultCompPlanist, setResultCompPlanist] = useState([]);
  const [compPlanFields, setcompPlanFields] = useState({
    resultCompPlanValue: [],
    resultcompPlanData: [],
    isResultcompPlanDataLoading: true,
  });
  const [resultNameFields, setResultNameFields] = useState({
    resultNameValue: [],
    resultNameData: [],
    isResultNameDataLoading: true,
  });
  const [resultNameList, setResultNameList] = useState([]);
  const [errorObj, setErrorObj] = useState({});
  const [periodsTypeFields, setPeriodTypeFields] = useState({
    periodTypeValue: {
      in_period_mstr_key: "",
      in_period_start_date: "",
      in_period_end_date: "",
    },
    periodTypeData: [],
    isPeriodTypeDataLoading: true,
  });
  const [specialtyDataFields, setSpecialtyDataFields] = useState({
    specialtyDataValue: [],
    specialtyData: [],
    isSpecialtyDataLoading: true,
    search: "",
    filterValue: "",
    specialtyDataList: [],
  });

  const [positionFields, setPositionDataFields] = useState({
    positionDataValue: [],
    positionData: [],
    isPositionLoading: true,
    search: "",
    filterValue: "",
    positionDataList: [],
  });

  const [groupDataFields, setGroupDataFields] = useState({
    groupDataValue: [],
    groupData: [],
    isGroupDataLoading: true,
    search: "",
    filterValue: "",
    groupDataList: [],
  });
  const [list, Action] = userResultsFilterApi();
  const [periodsList, setPeriodsList] = useState([]);
  const [periodsFields, setPeriodFields] = useState({
    periodsValue: [],
    periodsMultiSelValue: [],
    periodsData: [],
    isPeriodDataLoading: true,
  });
  const [periodTypeList, setPeriodTypeList] = useState([]);
  const defaultPageSize = getTenantCookieData("record_per_page");
  const [columns, setColumns] = useState([]);
  const [filterField, setFilterField] = useState({
    logic: "and",
    filters: [],
  });
  const [sortField, setSortField] = useState([]);
  const [columnsData, setColumnsData] = useState([]);
  const [isCheckColumn, setColumnCheck] = useState(false);
  const [gridColumns, setGridColumns] = useState([]);

  //state to set and get filter, sort number, sort order
  const [filterData, setFilterData] = useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    sort_order: DEFAULT_SORT.order,
  });

  const [resultFilterPageData, setResultFilterPageData] = useState({
    skip: 0,
    take: defaultPageSize.recordTake,
  });

  const [resultFilterPageSize, setResultFilterPageSize] = useState(defaultPageSize);
  const [apiCallData, setAPICallData] = useState(false);

  const [selectedState, setSelectedState] = useState({});
  const [selectedRowId, setSelectedRowId] = useState("");
  const [deleteSelectedIds, setDeleteSelectedIds] = useState([]);

  const DATA_ITEM_KEY = getRuleResultMasterKeyByPathname(history.location.pathname);
  const idGetter = getter(DATA_ITEM_KEY);

  const [isShow, setShow] = useState({
    deleteAllRows: false,
  });

  const [checked, setChecked] = useState(cookiesData?.out_db_role_type_abbr !== "adm1" ? false : true);

  const {
    resultFilterData,
    setResultFilterData,
    resultFilterDataCount,
    setResultFilterDataCount,
    resultFilterNoDataFound,
    resultFilterAPICalling,
    setResultFilterAPICallingState,
    originalFilterData,
    resultFilterLoadingState,
    setConfirmationPopup,
    confirmationPopup,
    sysConfigTimezone,
    setLoadingStateSearch,
    loading,
  } = list;

  useEffect(() => {
    if (columns.length > 0) {
      // let columnFilterData = [...columns];

      // if (checked) {
      //   columnFilterData.map((cItem) => {
      //     if (cItem.field === "is_active") {
      //       cItem.show = false;
      //     }
      //     return 0;
      //   });
      // } else {
      //   columnFilterData.map((cItem) => {
      //     if (cItem.field === "is_published") {
      //       cItem.show = false;
      //     }
      //     return 0;
      //   });
      // }

      // const manageColumns = checked
      //   ? columnsData.filter((x) => x.field !== "is_active")
      //   : columnFilterData.filter((x) => x.field !== "is_published");

      setColumnsData(columns);

      setGridColumns(columns);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, checked]);

  useEffect(() => {
    if (isCheckColumn) {
      setGridColumns(columnsData);
      setColumnCheck(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckColumn]);

  useEffect(() => {
    if (isCheckColumn) {
      updateColumDataAsync();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckColumn]);

  const mapToDropdown = (list, textKey, idKey) =>
    (list || []).map((item) => ({
      text: item[textKey],
      id: item[idKey],
    }));

  const getAllDropdownDataList = async () => {
    try {
      const reqData = {
        periodTypeParams: {
          in_filter: "AND a.period_type_hierarchy_level IS NOT NULL",
          in_sort_number: null,
          in_sort_order: null,
        },

        compPlanParams: {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_sort_number: 6,
          in_sort_order: "ASC",
          in_user_key: cookiesData.out_user_id,
          in_multi_sort_order: null,
          in_rule_result_table: getModule(history.location.pathname),
        },
        resultNameParams: {
          in_filter: null,
          in_sort_number: 2,
          in_sort_order: "ASC",
          in_user_key: cookiesData.out_user_id,
          in_rule_filter: null,
          in_user_id: cookiesData.out_user_id,
          in_tenant_id: cookiesData.out_tenant_id,
          in_rule_result_table: getModule(history.location.pathname),
          in_dash_tab_mstr_key: null,
        },
        specialtyParams: {
          in_user_key: cookiesData.out_user_id,
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_sort_number: 3,
          in_sort_order: "DESC",
          in_page_row_offset: 0,
          in_page_rows: 9999,
          in_rule_result_table: getModule(history.location.pathname),
        },
        groupParams: {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_user_role_filter: null,
          in_sort_number: 3,
          in_sort_order: null,
          in_page_row_offset: 0,
          in_page_rows: 9999,
          in_rule_result_table: getModule(history.location.pathname),
        },
        positionParams: {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_user_key: cookiesData.out_user_id,
          in_sort_number: 2,
          in_sort_order: "ASC",
          in_page_row_offset: 0,
          in_page_rows: 9999,
          in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
          in_user_role_filter: null,
          in_export_flag: 1,
          in_is_current_flag: 1,
          in_rule_result_table: getModule(history.location.pathname),
        },
      };

      const res = await Action.getAllDropdownData(reqData);

      // ================= PERIOD TYPE =================
      const periodList = mapToDropdown(res?.periodTypes?.row_result, "period_type_name", "period_type_mstr_key");

      if (periodList.length) {
        const defaultPeriod = getPeriodTypeData(periodList);
        getPeriodsDataList(defaultPeriod.id, periodList, "load");
        setPeriodTypeList(periodList);
        setPeriodTypeFields((prev) => ({
          ...prev,
          periodTypeData: periodList,
          periodTypeValue: defaultPeriod,
          isPeriodTypeDataLoading: false,
        }));
      } else {
        setPeriodTypeFields((prev) => ({
          ...prev,
          isPeriodTypeDataLoading: false,
        }));
      }

      // ================= COMP PLAN =================
      const compPlanList = mapToDropdown(res?.compPlans?.row_result, "comp_plan_name", "comp_plan_mstr_key");

      setResultCompPlanist(compPlanList);

      setcompPlanFields((prev) => ({
        ...prev,
        resultcompPlanData: compPlanList,
        isResultcompPlanDataLoading: false,
        resultCompPlanValue: compPlanList.length ? getCompPlanData(compPlanList) : [],
      }));

      // ================= RESULT NAME =================
      const resultNameList = mapToDropdown(res?.resultNames?.row_result, "result_name", "result_name_mstr_key");

      setResultNameList(resultNameList);

      setResultNameFields((prev) => ({
        ...prev,
        resultNameData: resultNameList,
        isResultNameDataLoading: false,
        resultNameValue: resultNameList.length ? getResultData(resultNameList) : [],
      }));

      // ================= SPECIALTY =================
      const specialtyList = mapToDropdown(res?.specialties?.row_result, "specialty_name", "specialty_mstr_key");

      setSpecialtyDataFields((prev) => ({
        ...prev,
        specialtyData: specialtyList,
        isSpecialtyDataLoading: false,
        specialtyDataList: specialtyList,
        specialtyDataValue: specialtyList.length ? SELECT_ALL : [],
      }));

      // ================= GROUP =================
      const groupList = mapToDropdown(res?.groups?.row_result, "title_name", "org_title_key");

      setGroupDataFields((prev) => ({
        ...prev,
        isGroupDataLoading: false,
        groupData: groupList,
        groupDataList: groupList,
        groupDataValue: groupList.length ? SELECT_ALL : [],
      }));

      // ================= POSITION =================
      const positionList = mapToDropdown(res?.positions?.row_result, "position_name", "org_position_key");

      setPositionDataFields((prev) => ({
        ...prev,
        isPositionLoading: false,
        positionData: positionList,
        positionDataList: positionList,
        positionDataValue: positionList.length ? SELECT_ALL : [],
      }));
    } catch (error) {
      console.error("getAllDropdownDataList error:", error);
    }
  };
  useEffect(() => {
    getAllDropdownDataList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStageChange = (e) => {
    setStateChange(e.state);
    if (e.state === "MINIMIZED") {
      setModal(false);
    } else if (e.state === "DEFAULT") {
      setModal(true);
    }
  };

  const updateColumDataAsync = async () => {
    setLoadingStateSearch({ ...loading, updateColumn: true });
    let columnString = executeGetColumnOrderInfo(columnsData, "event");
    let reqData = {
      in_db_name: "procare_system",
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter_logical_cond: "N",
      in_filter_label_cond: "N",
      in_column_info: columnString,
    };
    let res = await updateColumnReorderAsync(reqData, dispatch, history);
    if (res) {
      setLoadingStateSearch({ ...loading, updateColumn: false });
      setColumns(columnsData);
      setColumnCheck(false);
      setGridColumns(columnsData);
    } else {
      setLoadingStateSearch({ ...loading, updateColumn: false });
    }
  };

  const getVisibleSelectedItems = (selectionState = selectedState, data = resultFilterData) => {
    return data.reduce((acc, item) => {
      const itemId = idGetter(item);

      if (selectionState[itemId]) {
        acc.push({ id: Number(itemId) });
      }

      return acc;
    }, []);
  };

  const getDeleteDataReq = () => {
    const selectedItemsForDelete = filterData.isFilter ? getVisibleSelectedItems() : deleteSelectedIds;
    const selectedRuleIds = selectedItemsForDelete
      .filter((item) => item.id !== MULTI_SELECT_ALL_ID)
      .map((item) => item.id.toString())
      .join(",");

    let reqData = {
      in_result_type: getResultType(history.location.pathname),
      in_rule_results_key: selectedRuleIds,
      in_period_mstr_key:
        history.location.pathname === RESULT_TYPES.CREDITS ||
        periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === "year"
          ? periodsFields?.periodsValue?.id
          : Array.isArray(periodsFields?.periodsMultiSelValue)
            ? periodsFields.periodsMultiSelValue.map((item) => item.id).join(",")
            : periodsFields?.periodsValue?.id,
      in_result_name_mstr_key: extractIds(resultNameFields?.resultNameValue),
      in_comp_plan_mstr_key: extractIds(compPlanFields?.resultCompPlanValue),
      in_specialty_mstr_key: extractIds(specialtyDataFields?.specialtyDataValue),
      in_org_title_key: extractIds(groupDataFields?.groupDataValue),
      in_org_position_key: extractIds(positionFields?.positionDataValue),
    };
    return reqData;
  };

  const getDeleteSelectedRowsCount = () => {
    const selectedItemsForDelete = filterData.isFilter ? getVisibleSelectedItems() : deleteSelectedIds;

    return selectedItemsForDelete.filter((item) => item.id !== MULTI_SELECT_ALL_ID).length;
  };

  const onDeleteAllRecordConfirm = async () => {
    setConfirmationPopup({
      ...confirmationPopup,
      isVisible: false,
      type: "",
      actionBtn: [],
      data: {},
      action: "",
    });
    setResultFilterAPICallingState(true);
    const ids = [];
    for (const item of compPlanFields.resultCompPlanValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        ids.push(item.id.toString());
      }
    }
    const resultids = [];
    for (const item of resultNameFields.resultNameValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        resultids.push(item.id.toString());
      }
    }
    const positionids = [];
    for (const item of positionFields.positionDataValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        positionids.push(item.id.toString());
      }
    }
    const specailtyids = [];
    for (const item of specialtyDataFields.specialtyDataValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        specailtyids.push(item.id.toString());
      }
    }
    const groupids = [];
    for (const item of groupDataFields.groupDataValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        groupids.push(item.id.toString());
      }
    }
    const compPlanIds = ids.join(",");
    const resultsDataIds = resultids.join(",");
    const specailtyIds = specailtyids.join(",");
    const groupIds = groupids.join(",");
    const positionIds = positionids.join(",");
    let reqObj = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: getInFilter(),
      in_filter_linked_results: null,
      in_user_key: cookiesData.out_user_id,
      in_period_mstr_key:
        history.location.pathname === RESULT_TYPES.CREDITS ||
        periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === "year"
          ? periodsFields?.periodsValue?.id
          : Array.isArray(periodsFields?.periodsMultiSelValue)
            ? periodsFields?.periodsMultiSelValue?.map((item) => item.id).join(",")
            : periodsFields?.periodsValue?.id,
      in_result_name_all_flag: resultsDataIds.length === 0 ? 1 : 0,
      in_result_name_mstr_key: resultsDataIds,
      in_comp_plan_mstr_key: compPlanIds,
      in_aggregate_flag: 1,
      in_groupby: null,
      in_groupby_sort_order: null,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
      in_page_row_offset: 0,
      in_page_rows: defaultPageSize.recordTake,
      in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
      in_show_current_or_published: "AND (a.is_active = 1 OR a.is_published = 1)",
      in_user_id: cookiesData.out_user_id,
      in_user_role_filter: "> 0",
      in_specialty_mstr_key: specailtyIds,
      in_org_title_key: groupIds,
      in_org_position_key: positionIds,
      in_is_delete_all_flag: 1,
    };
    let apiName = "";
    let response = null;

    switch (history.location.pathname) {
      case RESULT_TYPES.CREDITS:
        apiName = GET_RESULT_CREDITS;
        break;
      case RESULT_TYPES.MEASUREMENTS:
        apiName = GET_RESULT_MEASUREMENTS;
        break;
      case RESULT_TYPES.INCENTIVES:
        apiName = GET_RESULT_INCENTIVES;
        break;
      case RESULT_TYPES.PAYMENTS:
        apiName = GET_RESULT_PAYMENTS;
        break;
      default:
        return;
    }
    response = await Action.getDeleteFilterData(reqObj, apiName, checked);
    if (response.status) {
      setPageMenuState(response.data);
      setDeleteSelectedIds([]);
      setSelectedState({});
      onRefreshClick();
      setSelectedRowId("");
      setErrorObj({});
      setConfirmationPopup({
        ...confirmationPopup,
        isVisible: false,
        type: "",
        actionBtn: [],
        data: {},
        action: "",
      });
      if (isResultDataLoad) {
        const resultKeys = getPeriodKeys(resultAPICallData?.in_period_mstr_key);
        const apiKeys = getPeriodKeys(apiCallData?.in_period_mstr_key);

        const shouldRefresh = apiKeys.some((key) => resultKeys.includes(key));

        if (shouldRefresh) {
          restProps.refreshGrid();
        }
      }
    }
  };
  const onDeleteConfirm = async () => {
    setConfirmationPopup({
      ...confirmationPopup,
      isVisible: false,
      type: "",
      actionBtn: [],
      data: {},
      action: "",
    });
    setResultFilterAPICallingState(true);
    let reqData = getDeleteDataReq();
    const res = await Action.DeleteResultData(reqData, apiCallData);
    if (res) {
      setDeleteSelectedIds([]);
      setSelectedState({});
      onRefreshClick();
      setSelectedRowId("");
      setErrorObj({});
      setConfirmationPopup({
        ...confirmationPopup,
        isVisible: false,
        type: "",
        actionBtn: [],
        data: {},
        action: "",
      });
      if (isResultDataLoad) {
        const resultKeys = getPeriodKeys(resultAPICallData?.in_period_mstr_key);
        const apiKeys = getPeriodKeys(apiCallData?.in_period_mstr_key);

        const shouldRefresh = apiKeys.some((key) => resultKeys.includes(key));

        if (shouldRefresh) {
          restProps.refreshGrid();
        }
      }
    }
  };

  const DeleteWarningIcon = () => (
    <span style={{ flex: "0 0 auto", lineHeight: 0 }} aria-hidden="true">
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#FEF2F2" />

        <circle cx="12" cy="12" r="8" fill="#EF4444" stroke="#DC2626" strokeWidth="1.5" />

        <path d="M12 8V12.5" stroke="white" strokeWidth="2.4" strokeLinecap="round" />

        <circle cx="12" cy="16" r="1.3" fill="white" />
      </svg>
    </span>
  );
  //  const DeleteWarningIcon = () => (
  //   <span style={{ flex: "0 0 auto", lineHeight: 0 }} aria-hidden="true">
  //     <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       {/* Background Deep Red */}
  //       <path d="M12 3L2 20H22L12 3Z" fill="#DC2626" stroke="#DC2626" strokeWidth="2" strokeLinejoin="round" />
  //       {/* Icon Shape - White for Contrast */}
  //       <path d="M12 9V13" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
  //       <path d="M12 17H12.01" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
  //     </svg>
  //   </span>
  // );

  const handleMenuItemClick = (module) => {
    switch (module) {
      case "delete":
        const selectedCount = getDeleteSelectedRowsCount();
        setShow({
          ...isShow,
          deleteRows: !isShow.deleteRows,
        });
        setConfirmationPopup({
          ...confirmationPopup,
          isVisible: true,
          type: "DELETE_CONFIRM",
          desc: (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <DeleteWarningIcon />
              <span style={{ lineHeight: 1.35 }}>
                Are you sure you want to delete <b>{selectedCount}</b> selected {selectedCount === 1 ? "row" : "rows"}?
              </span>
            </div>
          ),
          actionBtn: DELETE_BTN_ACTIONS(onCancelConfirm, onDeleteConfirm),
          data: [],
          action: "Delete",
        });
        break;
      case "Delete All inPeriod":
        const deleteAllCount = Number(resultFilterDataCount || resultFilterData?.length || 0);
        setShow({
          ...isShow,
          deleteRows: !isShow.deleteRows,
          deleteAllRows: true,
        });
        setConfirmationPopup({
          ...confirmationPopup,
          isVisible: true,
          desc: (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <DeleteWarningIcon />
              <span style={{ lineHeight: 1.35 }}>
                Are you sure you want to delete <b>{deleteAllCount}</b> results?
              </span>
            </div>
          ),
          type: "DELETE_CONFIRM",
          actionBtn: DELETE_BTN_ACTIONS(onCancelConfirm, onDeleteAllRecordConfirm),
          data: [],
          action: "delete_all",
        });
        break;
      default:
        break;
    }
  };

  const handleExportToExcel = () => {
    setLoadingStateSearch({ ...loading, updateColumn: true });
    let index = 1;
    if (originalFilterData.length > 0) {
      let obj = Object.keys(originalFilterData[0]);
      index = obj.findIndex((x) => x === sort[0].field) + 1;
    }
    let urlIndex = window.location.href.indexOf(`/${fetchRuleResultValue()}`);
    let currentURL = urlIndex !== -1 ? window.location.href.substring(0, urlIndex) : null;
    let reqData = {
      screenName: fetchScreenName(history.location.pathname),
      loggedInUserRole: cookiesData.out_db_role_type_abbr,
      isPopup: true,
      currentUrl: currentURL,
      paramArr: [
        {
          " -t ": cookiesData.out_tenant_id,
          " -u ": cookiesData.out_user_id,
          " -f ": "",
          " -c ": fetchExportProcName(history.location.pathname),
          " -e ": parseInt(periodsTypeFields.periodTypeValue.id),
          " -n ": index === 0 ? 1 : index,
          " -o ": sort ? sort[0].dir.toUpperCase() : "DESC",
          " -a ": cookiesData.out_acct_encrypt_key,
          " -s ": getInFilter() === null ? "NULL" : replaceEncKey(getInFilter(), cookiesData.out_acct_encrypt_key),
          " -b ":
            history.location.pathname === RESULT_TYPES.CREDITS ||
            periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === "year"
              ? periodsFields.periodsValue.id
              : periodsFields?.periodsMultiSelValue?.map((item) => item.id).join(","),
          " -d ":
            resultNameFields.resultNameValue.filter((x) => x.id !== MULTI_SELECT_ALL_ID).length === 0
              ? "0"
              : resultNameFields.resultNameValue
                  .filter((x) => x.id !== MULTI_SELECT_ALL_ID)
                  .map((item) => {
                    return item.id;
                  })
                  .toString(),
          " -h ":
            compPlanFields.resultCompPlanValue.filter((x) => x.id !== MULTI_SELECT_ALL_ID).length === 0
              ? "0"
              : compPlanFields.resultCompPlanValue
                  .filter((x) => x.id !== MULTI_SELECT_ALL_ID)
                  .map((item) => {
                    return item.id;
                  })
                  .toString(),
          " -i ":
            specialtyDataFields.specialtyDataValue.filter((x) => x.id !== MULTI_SELECT_ALL_ID).length === 0
              ? "0"
              : specialtyDataFields.specialtyDataValue
                  .filter((x) => x.id !== MULTI_SELECT_ALL_ID)
                  .map((item) => item.id)
                  .toString(),
          " -j ":
            groupDataFields.groupDataValue.filter((x) => x.id !== MULTI_SELECT_ALL_ID).length === 0
              ? "0"
              : groupDataFields.groupDataValue
                  .filter((x) => x.id !== MULTI_SELECT_ALL_ID)
                  .map((item) => item.id)
                  .toString(),
          " -l ":
            positionFields.positionDataValue.filter((x) => x.id !== MULTI_SELECT_ALL_ID).length === 0
              ? "0"
              : positionFields.positionDataValue
                  .filter((x) => x.id !== MULTI_SELECT_ALL_ID)
                  .map((item) => item.id)
                  .toString(),
          " -p ": checked ? "C" : "P",
          " -q ": "null",
          " -z ": "AND (a.is_active = 1 OR a.is_published = 1)",
          " -m ": "NULL",
          " -w ": "NULL",
        },
      ],
    };

    Action.exportResultData(reqData);
  };

  const headerConfig = {
    id: "manage-result",
    action_menu: {
      export: { fx: handleExportToExcel, caption: "Export to CSV" },
      delete: { fx: handleMenuItemClick },
      deleteAll: { fx: handleMenuItemClick, caption: "Delete Grid Results" },
    },
    manage_col: {
      columnsData: columnsData,
      setColumnsData: setColumnsData,
      setColumnCheck: setColumnCheck,
    },
  };

  const getPeriodTypeData = (dataSet) => {
    if (!dataSet[0]) {
      return { text: "", id: "" };
    }
    let returnObj = {};

    if (!returnObj?.id) {
      return dataSet[0];
    }

    return returnObj;
  };

  const getCompPlanData = (dataSet) => {
    return dataSet.length > 0 ? SELECT_ALL : [dataSet[0]];
  };

  const getResultData = (dataSet) => {
    return dataSet.length > 0 ? SELECT_ALL : [dataSet[0]];
  };

  const getPeriodsDataList = async (id, resultDataValue, method) => {
    setPeriodFields({
      ...periodsFields,
      isPeriodDataLoading: true,
      isResultcompPlanDataLoading: true,
      isResultNameDataLoading: true,
    });
    let periodsDataReq = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: `AND a.period_type_mstr_key = ${id}`,
      in_sort_number: null,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 9999,
      in_sort_number_concat: "a.period_end_date DESC, a.period_level_order DESC",
    };
    let resPeriods = await GetPeriodsDataList(periodsDataReq, dispatch, history);
    if (resPeriods.length > 0) {
      let tempArray = [];
      resPeriods.map((item) => {
        let obj = {};
        obj.text = item.period_name;
        obj.id = item.period_mstr_key;
        obj.in_period_start_date = item.period_start_date;
        obj.in_period_end_date = item.period_end_date;
        tempArray.push(obj);
        return 0;
      });
      setPeriodsList(tempArray);
      setPeriodFields({
        ...periodsFields,
        periodsData: tempArray,
        periodsValue: tempArray[0],
        periodsMultiSelValue: [],
        isPeriodDataLoading: false,
        isResultcompPlanDataLoading: false,
        isResultNameDataLoading: false,
      });
    } else {
      setPeriodsList([]);
      setPeriodFields({
        periodsValue: [],
        periodsData: [],
        isPeriodDataLoading: false,
        isResultcompPlanDataLoading: false,
        isResultNameDataLoading: false,
      });
    }
  };

  const setPageMenuState = (response, syncSelectionToVisibleRows = false, clearSelection = false) => {
    if (clearSelection) {
      setSelectedState({});
      setDeleteSelectedIds([]);
      setSelectedRowId("");
      return false;
    }

    if (!Object.keys(selectedState).length) {
      setSelectedRowId("");
      return false;
    }

    const visibleSelectedIds = getVisibleSelectedItems(selectedState, response);
    setSelectedRowId(visibleSelectedIds.length ? visibleSelectedIds[0].id : "");
    return false;
  };

  const GetListAsync = async (
    module,
    prepareRequestData,
    syncSelectionToVisibleRows = false,
    clearSelection = false
  ) => {
    let apiName = "";
    let response = null;

    switch (module) {
      case RESULT_TYPES.CREDITS:
        apiName = GET_RESULT_CREDITS;
        break;
      case RESULT_TYPES.MEASUREMENTS:
        apiName = GET_RESULT_MEASUREMENTS;
        break;
      case RESULT_TYPES.INCENTIVES:
        apiName = GET_RESULT_INCENTIVES;
        break;
      case RESULT_TYPES.PAYMENTS:
        apiName = GET_RESULT_PAYMENTS;
        break;
      default:
        return;
    }
    response = await Action.getDeleteFilterData(prepareRequestData, apiName, checked);
    if (response.status) {
      setPageMenuState(response.data, syncSelectionToVisibleRows, clearSelection);
    }
  };

  const getColumnAPIAsyc = (module, isListAPICall) => {
    const reqData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: " AND ( (a.result_name_column = 0) )",
      in_filter_db_name: "procare_system",
      in_filter_table_name: "vw_" + getModule(history.location.pathname),
      in_result_name_mstr_key: 0,
      in_event_type_mstr_key: "0",
      in_hide_column: 0,
    };
    POSTAPI(false, GET_SELECT_GRID_COLUMN_XML, null, header, reqData, dispatch).then((res) => {
      if (res.data.out_parameters.out_ret_code > 0) {
        dispatch(
          setNewMessage({
            message: res.data.out_parameters.out_error_msg,
            type: "Error",
            show: true,
          })
        );
        // setLoadingState(true);
        setResultFilterAPICallingState(false);
        errStatusHandler(res, history, dispatch);
      } else {
        const columData = GridColumnDataMapper(res.data.out_parameters.out_columns_xml, "field_proceed", true);
        let columnFilterData = [...columData];

        // if (checked) {
        //   columnFilterData.map((cItem) => {
        //     if (cItem.field === "is_active") {
        //       cItem.show = false;
        //     }
        //     return 0;
        //   });
        // } else {
        //   columnFilterData.map((cItem) => {
        //     if (cItem.field === "is_published") {
        //       cItem.show = false;
        //     }
        //     return 0;
        //   });
        // }

        // const manageColumns = checked
        //   ? columData.filter((x) => x.field !== "is_active")
        //   : columnFilterData.filter((x) => x.field !== "is_published");

        setColumnsData(columnFilterData);
        setColumns([]);
        setColumns(JSON.parse(JSON.stringify(columnFilterData)));
        if (isListAPICall) {
          getGridData(module, true);
        }
      }
    });
  };

  const getGridData = async (module, clearSelection = false) => {
    const ids = [];
    for (const item of compPlanFields.resultCompPlanValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        ids.push(item.id.toString());
      }
    }
    const resultids = [];
    for (const item of resultNameFields.resultNameValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        resultids.push(item.id.toString());
      }
    }
    const positionids = [];
    for (const item of positionFields.positionDataValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        positionids.push(item.id.toString());
      }
    }
    const specailtyids = [];
    for (const item of specialtyDataFields.specialtyDataValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        specailtyids.push(item.id.toString());
      }
    }
    const groupids = [];
    for (const item of groupDataFields.groupDataValue) {
      if (item.id !== MULTI_SELECT_ALL_ID) {
        groupids.push(item.id.toString());
      }
    }
    const compPlanIds = ids.join(",");
    const resultsDataIds = resultids.join(",");
    const specailtyIds = specailtyids.join(",");
    const groupIds = groupids.join(",");
    const positionIds = positionids.join(",");
    let reqObj = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: null,
      in_filter_linked_results: null,
      in_user_key: cookiesData.out_user_id,
      in_period_mstr_key:
        history.location.pathname === RESULT_TYPES.CREDITS ||
        periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === "year"
          ? periodsFields?.periodsValue?.id
          : Array.isArray(periodsFields?.periodsMultiSelValue)
            ? periodsFields?.periodsMultiSelValue?.map((item) => item.id).join(",")
            : periodsFields?.periodsValue?.id,
      in_result_name_all_flag: resultsDataIds.length === 0 ? 1 : 0,
      in_result_name_mstr_key: resultsDataIds,
      in_comp_plan_mstr_key: compPlanIds,
      in_aggregate_flag: 1,
      in_groupby: null,
      in_groupby_sort_order: null,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
      in_page_row_offset: 0,
      in_page_rows: defaultPageSize.recordTake,
      in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
      in_show_current_or_published: "AND (a.is_active = 1 OR a.is_published = 1)",
      in_user_id: cookiesData.out_user_id,
      in_user_role_filter: "> 0",
      in_specialty_mstr_key: specailtyIds,
      in_org_title_key: groupIds,
      in_org_position_key: positionIds,
    };
    setAPICallData(reqObj);
    await GetListAsync(history.location.pathname, reqObj, false, clearSelection);
    setLoadingStateSearch({ ...loading, isSearchLoader: false });
  };

  const onSearchButtonClick = async () => {
    setDeleteSelectedIds([]);
    setSelectedRowId("");
    setSelectedState({});
    setLoadingStateSearch({ ...loading, isSearchLoader: true });
    setResultFilterAPICallingState(true);
    setResultFilterPageSize(defaultPageSize);
    setResultFilterDataCount(0);
    setResultFilterPageData({
      skip: 0,
      take: defaultPageSize.recordTake,
    });
    setResultFilterData([]);
    setColumns([]);
    setFilterData({
      isSort: false,
      isFilter: false,
      data: "",
      in_sort_number: DEFAULT_SORT.number,
      sort_order: DEFAULT_SORT.order,
    });
    setFilterField({ logic: "and", filters: [] });
    setSortField([]);
    getColumnAPIAsyc(history.location.pathname, true);
  };

  const StringReadAndOnlyCell = memo((props) => {
    const { ariaColumnIndex, columnIndex, dataItem, field, colSpan } = props;
    const val = dataItem?.[field] ?? "";

    return (
      <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex} colSpan={colSpan}>
        <span title={val}>{val}</span>
      </td>
    );
  });

  const DynamicNumberCell = memo((props) => {
    const { ariaColumnIndex, columnIndex, colSpan } = props;
    const value = props.dataItem[props.field];
    const format = props.format;
    const formattedValue = !isNaN(value) ? applyFormat(value, format) : value;
    return (
      <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex} colSpan={colSpan}>
        <span title={formattedValue}>{formattedValue}</span>
      </td>
    );
  });

  const DateCell = memo((props) => {
    const { ariaColumnIndex, columnIndex, dataItem, field } = props;

    let val = dataItem[field];

    if (field === "action_date") {
      val =
        dataItem[field] && dataItem[field] !== "0000-00-00 00:00:00"
          ? convertTimeZone({
              date: dataItem[field],
              convertTimeZone: sysConfigTimezone,
            })
          : "";
    } else {
      val =
        dataItem[field] && dataItem[field] !== "0000-00-00 00:00:00"
          ? transformDateTime({
              date: dataItem[field],
              format: "MM-DD-YYYY",
              includeTime: true,
            })
          : "";
    }

    return (
      <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
        <span title={val}>{val}</span>
      </td>
    );
  });

  const useCol = (columns) => {
    return columns.map((column, idx) => {
      return column.show && column.title !== "" ? (
        <Column
          {...columnMenuProps(column)}
          key={idx}
          sortable={true}
          width={column.min_width}
          format={column.format}
          cell={
            column.type === "date" ? DateCell : column.type === "number" ? DynamicNumberCell : StringReadAndOnlyCell
          }
        />
      ) : (
        false
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  let CustomColumn = useCol(gridColumns);

  const getInFilter = () => {
    return filterData.isFilter ? filterData.data : null;
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const getPageTake = () => {
    return resultFilterPageData.take;
  };

  const getPageSkip = () => {
    return resultFilterPageData.skip;
  };

  const onRefreshClick = () => {
    setResultFilterAPICallingState(true);
    const dataVal = {
      ...apiCallData,
      in_show_current_or_published: "AND (a.is_active = 1 OR a.is_published = 1)",
    };
    setAPICallData(dataVal);
    GetListAsync(history.location.pathname, dataVal);
  };

  const onClearFilter = () => {
    setResultFilterAPICallingState(true);
    setFilterField({ logic: "and", filters: [] });
    //set in_params
    const dataVal = {
      ...apiCallData,
      in_filter: null,
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };

    //set filter to false
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
    });
    setAPICallData(dataVal);

    GetListAsync(history.location.pathname, dataVal, true);
  };

  const onSelectionChange = (event) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setSelectedState(newSelectedState);
    let tempArray = [];

    Object.keys(newSelectedState).map((item) => {
      if (newSelectedState[item] === false) {
        return 0;
      }
      let obj = {};
      obj.id = Number(item);
      tempArray.push(obj);
      return 0;
    });
    const visibleSelectedItems = getVisibleSelectedItems(newSelectedState, resultFilterData);
    setDeleteSelectedIds(tempArray);
    setSelectedRowId(visibleSelectedItems.length ? visibleSelectedItems[0].id : "");
  };

  const handlePageChange = (event) => {
    setResultFilterAPICallingState(true);
    const pageData = event.page;
    setResultFilterPageData({ skip: pageData.skip, take: pageData.take });
    const dataVal = {
      ...apiCallData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_rows: pageData.take,
      in_page_row_offset: pageData.skip,
    };
    setAPICallData(dataVal);
    GetListAsync(history.location.pathname, dataVal);
  };

  const handleColumnMenu = async (columnMenuData, isFilter, isSort, filterObj) => {
    let index = 1;
    let filterSkip = getPageSkip();
    let filterTake = getPageTake();

    if (isFilter) {
      filterSkip = 0;
      filterTake = resultFilterPageSize.recordTake;

      setFilterField(filterObj);

      //reset pager when filter applies
      setResultFilterPageData({ skip: filterSkip, take: filterTake });
    }
    if (isSort) {
      setSortField(columnMenuData);
    }

    if (resultFilterData.length > 0 && columnMenuData[0] !== undefined) {
      let obj = Object.keys(resultFilterData[0]);
      index = obj.findIndex((x) => x === columnMenuData[0].field) + 1;
    }

    const filterString = isFilter ? getfilterDataString(columnMenuData, gridColumns) : filterData.data;

    isFilter = false;
    if (filterString !== "") {
      isFilter = true;
    }

    let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
    let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

    isSort = !columnMenuData.length ? false : filterData.isSort;

    if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
      isSort = true;
      sortDir = columnMenuData[0].dir.toUpperCase();
      sortNumber = index;
    }
    const dataVal = {
      ...apiCallData,
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: isFilter ? filterString : null,
      in_sort_number: sortNumber,
      in_sort_order: sortDir,
      in_page_row_offset: filterSkip,
      in_page_rows: filterTake,
      in_user_key: cookiesData.out_user_id.toString(),
      in_user_role_filter: "> 0",
    };

    setFilterData({
      ...filterData,
      isFilter: isFilter,
      isSort: isSort,
      data: filterString,
      in_sort_number: sortNumber,
      sort_order: sortDir,
    });
    setAPICallData(dataVal);

    setResultFilterAPICallingState(true);
    await GetListAsync(history.location.pathname, dataVal, isFilter);
  };

  const cellRender = (td, props) => {
    return (
      <CellRender
        navigatable={true}
        originalProps={props}
        td={td}
        updateActBtn="grid-incell-update"
        cancelActBtn="grid-incell-cancel"
      />
    );
  };

  const rowRender = (tr, props) => <RowRender originalProps={props} tr={tr} />;

  const onCancelConfirm = (action) => {
    setConfirmationPopup({
      ...confirmationPopup,
      isVisible: false,
      type: "",
      actionBtn: [],
      data: {},
      action: "",
    });
  };

  const parent = document.querySelector("#content-" + headerConfig.id);

  if (parent) {
    const deleteRows = parent.querySelector(".delete-rows");
    const deleteAllRows = parent.querySelector(".delete-allrows-batch");

    deleteRows && deleteRows.disableKendoMenu();
    deleteAllRows && deleteAllRows.disableKendoMenu();

    const exportToExcel = parent.querySelector(".export-to-excel");
    exportToExcel && exportToExcel.disableKendoMenu();
    resultFilterData.length && exportToExcel && exportToExcel.enableKendoMenu();

    if (resultFilterData.length > 0) {
      deleteAllRows && deleteAllRows.enableKendoMenu();
    }

    if (selectedRowId !== "") {
      deleteRows && deleteRows.enableKendoMenu();
    }
  }

  const prepareColumnString = (colData) => {
    return executeGetColumnOrderInfo(colData);
  };

  const columnReorderData = async (columnData) => {
    const columnString = prepareColumnString(columnData);
    setLoadingStateSearch({ ...loading, updateColumn: true });
    let reqData = {
      in_db_name: "procare_system",
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter_logical_cond: "N",
      in_filter_label_cond: "N",
      in_column_info: columnString,
    };
    let res = await updateColumnReorderAsync(reqData, dispatch, history);
    if (res) {
      setLoadingStateSearch({ ...loading, updateColumn: false });
      let colDataList = JSON.parse(JSON.stringify(columnData));
      colDataList.forEach((item) => {
        item.hidden = false;
      });
      const mergedArray = columns.map((item1) => {
        const item2 = colDataList.find((item) => item.field === item1.field); // Find matching item by id
        return {
          ...item1,
          ...item2,
        };
      });
      let colData = mergedArray.sort(function (a, b) {
        return a?.ariaColumnIndex - b?.ariaColumnIndex;
      });
      setColumnsData(colData);
      setColumns([]);
      setColumns(JSON.parse(JSON.stringify(colData)));
    } else {
      setLoadingStateSearch({ ...loading, updateColumn: false });
    }
  };

  const handleChange = (e) => {
    setChecked(e.value);
  };
  return (
    <>
      <Window
        modal={modal}
        title={<ModalTitle />}
        onClose={restProps.onClose}
        width={window.innerWidth * 0.95}
        height={window.innerHeight * 0.9}
        resizable={false}
        stage={stageChange}
        onStageChange={handleStageChange}
      >
        <div className="dtu-file-container-logs manageeventtype-dialogue">
          <div className="content">
            <div className="Quick-links eventtypequicklinks">
              <HeaderPage pageProps={restProps} headerConfig={headerConfig} />
            </div>
          </div>
          <div className="content-body">
            {" "}
            <ul className="Filter-links creditfilters delete-result-filter">
              <div className={"k-form-field-wrap-popup width20em"} ref={divRef}>
                <Label>{"Period Type:"}</Label>
                <CustomDropdown
                  name={"periodTypeValue"}
                  data={periodsTypeFields.periodTypeData}
                  textField="text"
                  onOpen={(dataValue) => {
                    setPeriodTypeFields({
                      ...periodsTypeFields,
                      periodTypeData: dataValue,
                    });
                  }}
                  dataItemKey="id"
                  valueData={periodTypeList.find((c) => c.text === periodsTypeFields.periodTypeValue.text)}
                  onChange={(e, name) => {
                    setPeriodTypeFields({
                      ...periodsTypeFields,
                      [name]: e,
                    });
                    if (e.text === "year") {
                      // do nothing
                    } else {
                      setTimeout(() => {
                        divRefForMultiSelectPeriod?.current?.focusInput();
                      }, 0);
                    }

                    getPeriodsDataList(e.id, "load");
                  }}
                  filterable={true}
                  onFilterChange={(dataValue) => {
                    setPeriodTypeFields({
                      ...periodsTypeFields,
                      periodTypeData: dataValue,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  dataList={periodTypeList}
                  loading={periodsTypeFields.isPeriodTypeDataLoading}
                  disabled={periodsTypeFields.isPeriodTypeDataLoading}
                />
              </div>
              {periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === "year" ||
              history.location.pathname === RESULT_TYPES.CREDITS ? (
                <div
                  className={"k-form-field-wrap-popup valueDropdown width20em"}
                  // ref={divRef}
                >
                  <Label>{"Periods:"}</Label>

                  <CustomDropdown
                    name={"periodsValue"}
                    data={periodsFields.periodsData}
                    textField="text"
                    onOpen={(dataValue) => {
                      setPeriodFields({
                        ...periodsFields,
                        periodsData: dataValue,
                      });
                    }}
                    dataItemKey="id"
                    valueData={periodsList.find((c) => c.text === periodsFields.periodsValue.text)}
                    onChange={(e, name) => {
                      setPeriodFields({
                        ...periodsFields,
                        [name]: e,
                      });
                    }}
                    filterable={true}
                    onFilterChange={(dataValue) => {
                      setPeriodFields({
                        ...periodsFields,
                        periodsData: dataValue,
                      });
                    }}
                    autoClose={false}
                    autoBind={true}
                    isSelectALl={true}
                    dataList={periodsList}
                    loading={periodsFields.isPeriodDataLoading}
                    disabled={periodsFields.isPeriodDataLoading}
                  />
                </div>
              ) : (
                <div className={"k-form-field-wrap-popup valueDropdown "}>
                  {periodsFields.periodsData.length > 0 ? (
                    <Label>
                      Periods
                      <span
                        className="tooltip space-between"
                        data-tooltip-location="right"
                        data-tooltip={
                          periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === PERIODSTYPE.QUARTER
                            ? MessageSchema?.quarterLimit
                            : MessageSchema?.monthLimit
                        }
                      >
                        <i className="fas fa-info-circle"></i> :
                      </span>
                    </Label>
                  ) : (
                    <Label>Periods:</Label>
                  )}

                  <MultiSelectDropdown
                    name={"periodsMultiSelValue"}
                    module="compPlanName"
                    data={periodsFields.periodsData}
                    textField="text"
                    onOpen={(dataValue) => {
                      setPeriodFields({
                        ...periodsFields,
                        periodsData: dataValue,
                      });
                    }}
                    isPeriodSelect={true}
                    dataItemKey="id"
                    valueData={periodsFields.periodsMultiSelValue}
                    ref={divRefForMultiSelectPeriod}
                    onChange={(e, name) => {
                      const prevValues = periodsFields.periodsMultiSelValue;
                      const firstValue = prevValues?.[0];
                      let newValues = [...e];

                      const isChipRemoval = prevValues.length - newValues.length === 1;

                      if (e.length === 0) {
                        newValues = [];
                      } else {
                        if (isChipRemoval) {
                          if (newValues.length === 0) {
                            newValues = [firstValue];
                          }
                        } else {
                          if (
                            firstValue &&
                            !newValues.some((v) => v.id === firstValue.id) &&
                            prevValues.some((v) => v.id === firstValue.id)
                          ) {
                            newValues = [firstValue, ...newValues];
                          }
                        }
                      }

                      const type = periodsTypeFields?.periodTypeValue?.text?.toLowerCase();

                      if (type === PERIODSTYPE.QUARTER && newValues.length <= 4) {
                        setPeriodFields({
                          ...periodsFields,
                          [name]: newValues,
                        });
                        setErrorObj({ ...errorObj, [name]: "" });
                      } else if (type === PERIODSTYPE.MONTH && newValues.length <= 12) {
                        setPeriodFields({
                          ...periodsFields,
                          [name]: newValues,
                        });
                        setErrorObj({ ...errorObj, [name]: "" });
                      } else if (type === PERIODSTYPE.YEAR) {
                        setPeriodFields({
                          ...periodsFields,
                          [name]: newValues,
                        });
                        setErrorObj({ ...errorObj, [name]: "" });
                      }
                    }}
                    filterable={true}
                    onFilterChange={(dataValue) => {
                      setPeriodFields({
                        ...periodsFields,
                        periodsData: dataValue,
                      });
                    }}
                    dataList={periodsList}
                    loading={periodsFields.isPeriodDataLoading}
                    autoClose={false}
                    autoBind={true}
                    isPeriodDropdown={true}
                    selectionLimit={
                      periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === PERIODSTYPE.QUARTER
                        ? 4
                        : periodsTypeFields?.periodTypeValue?.text?.toLowerCase() === PERIODSTYPE.MONTH
                          ? 12
                          : null
                    }
                  />
                </div>
              )}
              <div className={"k-form-field-wrap-popup valueDropdown"} ref={divRef}>
                <Label>{"Comp Plan:"}</Label>
                <MultiSelectDropdown
                  name={"resultCompPlanValue"}
                  module="compPlanName"
                  data={compPlanFields.resultcompPlanData}
                  textField="text"
                  onOpen={(dataV) => {
                    setcompPlanFields({
                      ...compPlanFields,
                      resultcompPlanData: dataV,
                    });
                  }}
                  dataItemKey="id"
                  valueData={compPlanFields.resultCompPlanValue}
                  onChange={(data, name) => {
                    setcompPlanFields({
                      ...compPlanFields,
                      [name]: data,
                    });
                    setErrorObj({
                      ...errorObj,
                      [name]: "",
                    });
                  }}
                  filterable={true}
                  onFilterChange={(data) => {
                    setcompPlanFields({
                      ...compPlanFields,
                      resultcompPlanData: data,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  selectAllId={"0"}
                  dataList={resultCompPlanist}
                  loading={compPlanFields.isResultcompPlanDataLoading}
                  disabled={compPlanFields.isResultcompPlanDataLoading}
                />
              </div>
              <div className={"k-form-field-wrap-popup valueDropdown"} ref={divRef}>
                <Label>{"Result Name:"}</Label>
                <MultiSelectDropdown
                  name={"resultNameValue"}
                  module="resultName"
                  data={resultNameFields.resultNameData}
                  textField="text"
                  onOpen={(data) => {
                    setResultNameFields({
                      ...resultNameFields,
                      resultNameData: data,
                    });
                  }}
                  dataItemKey="id"
                  valueData={resultNameFields.resultNameValue}
                  onChange={(data, name) => {
                    setResultNameFields({
                      ...resultNameFields,
                      [name]: data,
                      // resultNameData: resultNameList,
                    });
                    setErrorObj({
                      ...errorObj,
                      [name]: "",
                    });
                  }}
                  filterable={true}
                  onFilterChange={(data) => {
                    setResultNameFields({
                      ...resultNameFields,
                      resultNameData: data,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  selectAllId={"0"}
                  dataList={resultNameList}
                  loading={resultNameFields.isResultNameDataLoading}
                  disabled={resultNameFields.isResultNameDataLoading}
                />
              </div>

              <div className="k-form-field-wrap-popup valueDropdown" ref={divRef}>
                <Label>Specialty:</Label>
                <MultiSelectDropdown
                  name={"specialtyDataValue"}
                  module="specialtyName"
                  data={specialtyDataFields.specialtyData}
                  textField="text"
                  onOpen={(data) => {
                    setSpecialtyDataFields({
                      ...specialtyDataFields,
                      specialtyData: data,
                    });
                  }}
                  dataItemKey="id"
                  valueData={specialtyDataFields.specialtyDataValue}
                  onChange={(data, name) => {
                    setSpecialtyDataFields({
                      ...specialtyDataFields,
                      [name]: data,
                    });
                    setErrorObj({
                      ...errorObj,
                      [name]: "",
                    });
                  }}
                  filterable={true}
                  onFilterChange={(data) => {
                    setSpecialtyDataFields({
                      ...specialtyDataFields,
                      specialtyData: data,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  selectAllId={"0"}
                  dataList={specialtyDataFields.specialtyDataList}
                  loading={specialtyDataFields.isSpecialtyDataLoading}
                  disabled={specialtyDataFields.isSpecialtyDataLoading}
                />
              </div>

              <div className="k-form-field-wrap-popup valueDropdown" ref={divRef}>
                <Label>Group:</Label>
                <MultiSelectDropdown
                  name={"groupDataValue"}
                  module="groupName"
                  data={groupDataFields.groupData}
                  textField="text"
                  onOpen={(data) => {
                    setGroupDataFields({
                      ...groupDataFields,
                      groupData: data,
                    });
                  }}
                  dataItemKey="id"
                  valueData={groupDataFields.groupDataValue}
                  onChange={(data, name) => {
                    setGroupDataFields({
                      ...groupDataFields,
                      [name]: data,
                      // resultNameData: resultNameList,
                    });
                    setErrorObj({
                      ...errorObj,
                      [name]: "",
                    });
                  }}
                  filterable={true}
                  onFilterChange={(data) => {
                    setGroupDataFields({
                      ...groupDataFields,
                      groupData: data,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  selectAllId={"0"}
                  dataList={groupDataFields.groupDataList}
                  loading={groupDataFields.isGroupDataLoading}
                  disabled={groupDataFields.isGroupDataLoading}
                />
              </div>

              <div className="k-form-field-wrap-popup valueDropdown" ref={divRef}>
                <Label>Position:</Label>
                <MultiSelectDropdown
                  name={"positionDataValue"}
                  module="positionName"
                  data={positionFields.positionData}
                  textField="text"
                  onOpen={(data) => {
                    setPositionDataFields({
                      ...positionFields,
                      positionData: data,
                    });
                  }}
                  dataItemKey="id"
                  valueData={positionFields.positionDataValue}
                  onChange={(data, name) => {
                    setPositionDataFields({
                      ...positionFields,
                      [name]: data,
                      // resultNameData: resultNameList,
                    });
                    setErrorObj({
                      ...errorObj,
                      [name]: "",
                    });
                  }}
                  filterable={true}
                  onFilterChange={(data) => {
                    setPositionDataFields({
                      ...positionFields,
                      positionData: data,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  selectAllId={"0"}
                  dataList={positionFields.positionDataList}
                  loading={positionFields.isPositionLoading}
                  disabled={positionFields.isPositionLoading}
                />
              </div>
              {/* {cookiesData?.out_db_role_type_abbr === "adm1" && (
                <div className="k-form-field-wrap-popup currentpublished">
                  <Label>{"Current/Published:"}</Label>
                  <Switch
                    className={"result-switch"}
                    thumbRounded={"medium"}
                    trackRounded={"medium"}
                    size={"medium"}
                    onChange={handleChange}
                    checked={checked}
                    onLabel={"CURRENT"}
                    offLabel={"PUBLISHED"}
                  />
                </div>
              )} */}
              <Button
                primary
                className="searchbtn deleteresultfilter"
                onClick={onSearchButtonClick}
                type="submit"
                disabled={
                  periodsTypeFields.isPeriodTypeDataLoading ||
                  periodsFields.isPeriodDataLoading ||
                  resultCompPlanist.isResultcompPlanDataLoading ||
                  resultNameFields.isResultNameDataLoading ||
                  periodsFields.length === 0 ||
                  periodTypeList.length === 0 ||
                  resultNameList.length === 0 ||
                  resultCompPlanist.length === 0 ||
                  specialtyDataFields.specialtyData.length === 0 ||
                  groupDataFields.groupData.length === 0 ||
                  positionFields.positionData.length === 0 ||
                  (history.location.pathname !== RESULT_TYPES.CREDITS &&
                    periodsTypeFields.periodTypeValue.text !== "year" &&
                    periodsFields.periodsMultiSelValue.length === 0)
                }
              >
                <i className="fas fa-search"></i>
              </Button>
            </ul>
          </div>
          {loading.updateColumn ? <LoadingPanel /> : false}
          {loading.isSearchLoader ? <LoadingPanel /> : false}
          {!loading.isSearchLoader && columns.length > 0 ? (
            <DataTable
              isAPICalling={resultFilterAPICalling}
              initialLoading={resultFilterLoadingState}
              data={resultFilterData.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
              }))}
              handleColumnMenu={handleColumnMenu}
              pageData={resultFilterPageData}
              dataCount={resultFilterDataCount}
              customColumn={CustomColumn}
              //    module={"delete-result"}
              // isColumnMenuSearch={isColumnMenuSearch}
              columns={gridColumns}
              dataItemKey={DATA_ITEM_KEY}
              width={"auto"}
              setSort={setSort}
              defaultPageSize={defaultPageSize}
              pageSize={resultFilterPageSize}
              setPageSize={setResultFilterPageSize}
              handlePageChange={handlePageChange}
              refreshClick={onRefreshClick}
              onClearFilter={onClearFilter}
              noDataFound={resultFilterNoDataFound}
              reorderable={restProps.writeAccess === 0 ? false : true}
              columnReorderData={columnReorderData}
              isFilterData={filterData.isFilter}
              initialFilter={filterField}
              initialSort={sortField}
              cellRender={cellRender}
              rowRender={rowRender}
              onSelectionChange={onSelectionChange}
            />
          ) : resultFilterLoadingState && resultFilterData.length === 0 ? (
            false
          ) : (
            false
          )}
          <DialogComponent
            title={confirmationPopup.title}
            onCancelConfirm={onCancelConfirm}
            width={"450"}
            height={"auto"}
            className={"Dialog-Delete"}
            desc={confirmationPopup.desc}
            visible={confirmationPopup.isVisible}
            actionBtn={confirmationPopup.actionBtn}
            titleClassName={confirmationPopup.action === "Delete" ? "delete-confirm" : "unSave-confirm"}
          />
        </div>
      </Window>
    </>
  );
};

export const GridButton = (restProps) => {
  return (
    <>
      <Button type="submit" className="cancelbtn" id="grid-incell-cancel">
        Cancel
      </Button>
      <Button type="submit" className="primarybtn" id="grid-incell-update">
        Save
      </Button>
    </>
  );
};

export default React.memo(DeleteResultFilter);
